// extracted by mini-css-extract-plugin
module.exports = {"clickable_label_fix":"beschikbare-serviceproviders_clickable_label_fix__bw0O2"};